var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgShieldBadge = function SvgShieldBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#B8B0D3",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.934 8.462l-4.5-1.875a1.124 1.124 0 00-.865 0l-4.5 1.875c-.42.173-.694.583-.694 1.038 0 4.652 2.684 7.868 5.191 8.913.277.115.589.115.865 0 2.009-.836 5.194-3.726 5.194-8.913 0-.455-.274-.865-.691-1.038zm-4.932 8.498L12 8.03l4.123 1.718c-.078 3.549-1.925 6.12-4.12 7.212z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgShieldBadge;